<!--<template>
  <div class="mycer-container">
    <div class="mycer-center text-center" :style="{backgroundImage: `url(${require('../../assets/gcla/my-certificate.png')})`}">
        <img :src="require('../../assets/img/icons/quality.svg')" class="mb-4 img-fluid" alt="">
        <div class="bg-title text-uppercase">My Certificate</div>
        <div class="text mb-3">You can view and print your certificate</div>
        <router-link to="/" class="nl-btn d-inline-block">
          <div class="d-flex align-items-center">
            <span v-html="'Verify Now'"></span>
            <span class="icon-back icon"></span>
          </div>
        </router-link>
    </div>
  </div>
</template>-->

<template>
  <div class="mycer-container">
    <div class="mycer-center text-center" 
      :style="{backgroundImage: `url(${row.image9}) !important`}">
        <img :src="require('../../assets/img/icons/quality.svg')" class="mb-4 img-fluid" alt="">
        <div class="bg-title" v-html="row.title9"></div>
        <div class="text mb-3" v-html="row.body9"></div>
        <router-link v-if="row.redirect9" :to="row.redirect9" class="nl-btn d-inline-block">
          <div class="d-flex align-items-center">
            <span v-html="row.button9"></span>
            <span class="icon-back icon"></span>
          </div>
        </router-link>
    </div>
  </div>
</template>

<style scoped>
.mycer-center {
  padding: 80px 20px;
  margin-bottom: 0.7rem;
  background-size: cover
}
.bg-title {
  color: #BF9000;
  font-size: 50px;
}
.text {
  color: #fff;
  font-size: 18px;
}
.icon {
  font-weight: bold;
}
.icon:before {
  color: #fff;
}
.nl-btn:hover .icon:before  {
  color: #000;
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
  
}

@media (max-width: 767.98px) {
  .bg-title {
    font-size: 37px;
  }
  .text {
    font-size: 16px;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {

}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
  
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {
  
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}
</style>

<script>
export default {
  name: "Section4",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
